import request from '@/libs/request'

export default {
  getSubscriber: (token) =>
    request({
      method: 'get',
      namespace: 'subscribers',
      url: '/',
      token
    }),
  getOfferings: () =>
    request({
      method: 'get',
      namespace: 'subscribers',
      url: '/offerings'
    })
}
